// User IDs whitelisted to see the root-level Dev Service Status menu entry.
// Mirrors the legacy single-user gate (profile.id === 12751) in
// mortgageboss_web Settings.js:235 — this is a single-developer internal
// diagnostic screen (service run status + SimplInsur creditor deployment), not
// a production feature. Kept as a set to match the sibling signalrAccess.ts and
// errorManagementAccess.ts shapes.
export const DEV_SERVICE_STATUS_USER_IDS: ReadonlySet<number> = new Set([12751])
